import alt from '../alt';
import generateWithAsyncActions from 'epic-alt-utils';
export default generateWithAsyncActions(alt, [], [
    'searchActive',
    'mobileNavActive',
    'mobileActiveLinkIndex',
    'egNavActive',
    'tabletNavActive',
    'mobileLocaleActive',
    'mobileUserActive',
    'mobileNavActiveLinks',
    'closeMobileTablet'
]);



/** WEBPACK FOOTER **
 ** ./app/scripts/actions/NavActions.js
 **/